import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=996ffdbe&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=996ffdbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996ffdbe",
  null
  
)

export default component.exports